// extracted by mini-css-extract-plugin
export var card = "_k6-5";
export var cardSelected = "_k6-4";
export var image = "_k6-3";
export var modal = "_k6-0";
export var modalContent = "_k6-1";
export var table = "_k6-2";